import UsuarioService from '@/src/services/usuario'

const usuarioMixin = {
  data() {
    return {
      usuariosFields: [
        {
          key: 'nome',
          label: 'Nome',
          class: 'size-col-20',
          field: 'nome',
        },
        {
          key: 'email',
          label: 'Email',
          class: 'size-col-20',
          field: 'email',
        },
        { key: 'actions', label: '', class: 'size-col-10' },
      ],
    }
  },
  methods: {
    async registerUsuario(usuario) {
      await UsuarioService.create(usuario)
    },
    loadUsuarios(filter) {
      let usuarios = []

      return UsuarioService.list(filter)
        .then((response) => {
          response.data.map((usuario) => usuarios.push(usuario._doc))
          return usuarios
        })
        .catch((error) => error)
    },
    async editUsuario(id, usuario) {
      await UsuarioService.update(id, usuario)
    },
    async deleteUsuario(id) {
      await UsuarioService.remove(id)
    },
  },
}

export default usuarioMixin
